import '.i{display:flex;}.ssr-plugin'
import '.ab{align-items:stretch;}.ssr-plugin'
import '.j{justify-content:center;}.ssr-plugin'
import '.r{flex-direction:column;}.ssr-plugin'
import '.cz{background:var(--shades-white);}.ssr-plugin'
import '.bn{flex-grow:1;}.ssr-plugin'
import '.s{align-items:center;}.ssr-plugin'
import '.at{max-width:77.5rem;}.ssr-plugin'
import '.cd{justify-content:stretch;}.ssr-plugin'
import '.ce{position:sticky;}.ssr-plugin'
import '.cf{top:0px;}.ssr-plugin'
import '.cg{z-index:10;}.ssr-plugin'
import '.dn{padding-block:1rem;}.ssr-plugin'
import '.do{height:3rem;}.ssr-plugin'
import '.a3{justify-content:space-between;}.ssr-plugin'
import '.c4{flex-wrap:wrap;}.ssr-plugin'
import '.dp{min-height:calc(100vh - 5rem);}.ssr-plugin'
import '.bh{margin-top:2rem;}.ssr-plugin'
import '.dq{padding-bottom:6rem;}.ssr-plugin'
import { ReactNode, useEffect } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { Title } from '@app/components/core/typography/Title'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { pages } from '@app/util/links'
import { useLocation } from 'wouter'
import { ClientOnly, useAuthState } from '@based/sdk/react'

export const PlotRegistryPageLayout = ({
  title,
  gap = '1rem',
  children,
  onClose,
}: {
  title: string
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
  onClose: VoidFunction
}) => {
  const isMobile = useMediaQuery()

  const authState = useAuthState()
  const [_location, navigate] = useLocation()
  const isAuthed = authState && authState.userId

  useEffect(() => {
    if (!isAuthed) {
      navigate(pages.home)
    }
  }, [isAuthed, navigate])

  return (
    <ClientOnly>
      <div className="i ab j r cz"
      >
        <div className="bn i s j r"
        >
          <div className="at i r cd ce cf cg cz"
            style={{
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            <nav className="dn do i a3 s c4"
            >
              <Title.H5>{title}</Title.H5>
              <CloseButton onClick={onClose} />
            </nav>
          </div>
          <div className="dp i r ab bh dq at"
            style={{
              gap: gap,
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            {children}
          </div>
        </div>
      </div>
    </ClientOnly>
  )
}
